import * as React from 'react'

export const IconCoupon = ({ fill = 'white', width = '11', height = '8' }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 11 8"
    fill={fill}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.5 3V1C10.5 0.45 10.05 0 9.5 0H1.5C0.95 0 0.505 0.45 0.505 1V3C1.055 3 1.5 3.45 1.5 4C1.5 4.55 1.055 5 0.5 5V7C0.5 7.55 0.95 8 1.5 8H9.5C10.05 8 10.5 7.55 10.5 7V5C9.95 5 9.5 4.55 9.5 4C9.5 3.45 9.95 3 10.5 3ZM9.5 2.27C8.905 2.615 8.5 3.265 8.5 4C8.5 4.735 8.905 5.385 9.5 5.73V7H1.5V5.73C2.095 5.385 2.5 4.735 2.5 4C2.5 3.26 2.1 2.615 1.505 2.27L1.5 1H9.5V2.27ZM4.035 6L5.5 5.06L6.965 6L6.52 4.32L7.865 3.22L6.13 3.115L5.5 1.5L4.865 3.11L3.13 3.215L4.475 4.315L4.035 6Z"
      fill={fill}
    />
  </svg>
)
